import { Select } from "antd";
import styles from "./ModeSelect.module.scss";

const ModeSelect = ({ mode, setMode }) => {
  return (
    <div className={styles["mode"]}>
      <p className={styles["mode--title"]}>Mode: </p>
      <Select
        style={{ width: 160 }}
        value={mode}
        onChange={(value) => setMode(value)}
        options={[
          { value: "all", label: "All" },
          { value: "internal", label: "Internal" },
          { value: "external", label: "External" },
        ]}
        placeholder="Select an option"
      />
    </div>
  )
}

export default ModeSelect